import useLoginOTPLifeCycle from "./useLoginOTPLifeCycle";
import useLoginOTPInterface from "./useLoginOTPInterface";

const useLoginOTPProvider = () => {
  useLoginOTPLifeCycle();
  useLoginOTPInterface();
};

export default useLoginOTPProvider;
